// extracted by mini-css-extract-plugin
export default {"blogItem":"styles_blogItem__zJCBi","imgWrapper":"styles_imgWrapper__bJe3O","contentWrapper":"styles_contentWrapper__u8yhD","infoWrapper":"styles_infoWrapper__NYHF2"};